<template lang="pug">
  .pdp-ctas(:class="{ 'waitlist': showWaitlistForm }" itemprop="offers" itemtype="http://schema.org/Offer" itemscope)
    meta(itemprop="itemCondition" content="https://schema.org/NewCondition")
    meta(itemprop="availability" content="https://schema.org/InStock" v-if="product.inventory_status === 'active'")
    meta(itemprop="price" :content="product.price")
    meta(itemporp="priceCurrency", content="USD")

    .waitlist-section(v-if="showWaitlistForm")
      .stock-warning-msg.row
        .xs-2.text-center(:class="{ 'xs-pt-50m': product.preorder_promise_date }")
          i.icon-warning.xs-f-xlarge.max-at-tweak

        .xs-10.text-left
          p.xs-f-xsmall.lg-f-small.max-at-tweak.bold(:class="{ 'xs-pt-25m': !product.preorder_promise_date }") Temporarily out of stock.
          p.xs-f-xsmall.lg-f-small.max-at-tweak(v-if="product.preorder_promise_date") Expected availability the week of {{ $formatDate(product.preorder_promise_date, 'MM/DD') }}.

      .help-msg.xs-pt-100m.xs-pb-150m.side-padding
        p.xs-f-small.lg-f-small.max-at-tweak.text-left(v-if="advisorCompleted && product.product_type == 'color_kit'") Click '+ More Colors' to see your other recommended shades.

      WaitlistForm.xs-ml-10pct.xs-mr-10pct(:product-id="product.id" :inventory-status="product.inventory_status")

    .waitlist-section(v-if="isProductDiscontinued")
      .discontinued-msg.row
        i.icon-warning.xs-f-xlarge.max-at-tweak
        p.xs-f-xsmall.lg-f-small.max-at-tweak.bold This product has been discontinued.

    StickyWrap(stop-at="footer" :permanent="isMobile && version === 'B'" @fixed="sticking = true" @unfixed="sticking = false" @stopped="stopped = true" @unstopped=" stopped = false")
      template(v-if="ctasInitialized && product.inventory_status == 'active'")
        MountedFlag(v-if="isMobile" flag="with-sticky-cta")
        .ctas-wrap
          ChangeColorCTAs(v-if="subscription.id")

          AddProduct(cta-source="ctaSource" )

            template(#default="{ addProductToOrderOrBag, addToBag, canAddToRefillCart, addingToBag }")
              .add-product-cta.xs-12(:class="{'add-extra-padding': addExtraPadding }")

                AfterpayMessaging.afterpay-message(
                  :class="{ 'bold cw-color-11': isColorWonder }"
                  v-if="buttonDisplayPrice && mix_afterpayFeatureActive"
                  :size="afterpayMsgSize"
                  :amount="buttonDisplayPrice"
                  intro-text="Pay in"
                )

                button.purchase-btn.mr-btn.xs-f-xsmall.max-at-tweak.xs-mb-75m(
                  type="button"
                  ref="addButton"
                  @click="addProductToOrderOrBag($refs.addButton)"
                  data-mr-ass="floating-purchase-panel-button"
                  :class="{ 'xs-f-xsmall': !isColorWonder, 'xs-12': !isColorWonder || isColorWonder && isMobile, 'has-from-text': displayFromText && buttonDisplayPrice, disabled: addingToBag, 'btn-inverse hide-in-sticky': activeSubAndSameProductNotSelected, 'half-button': canAddToRefillCart, 'btn-round color-wonder xs-f-small': isColorWonder }"
                )
                  span {{ mainCtaText(canAddToRefillCart) }}
                  span(v-if="skipPurchasePanel && buttonDisplayPrice")  | {{ $currency(buttonDisplayPrice) }}
                  span.cw-from-text.bold.cw-color-2.normal(v-if="displayFromText && buttonDisplayPrice && isColorWonder") &nbsp;-&nbsp;From #[strike(v-if="buttonDisplayStrikePrice") {{ $currency(buttonDisplayStrikePrice) }}] {{ $currency(buttonDisplayPrice) }}
                  span.lower.normal.from-text(v-else-if="displayFromText && buttonDisplayPrice" :class="{'add-from-height': isPerfectPairPdp }") from #[strike(v-if="buttonDisplayStrikePrice") {{ $currency(buttonDisplayStrikePrice) }}] {{ $currency(buttonDisplayPrice) }}

                button.xs-12.buy-now-btn.mr-btn.btn-inverse.xs-f-xsmall.max-at-tweak.xs-mb-75m.half-button(
                  v-if="canAddToRefillCart"
                  type="button"
                  @click="addToBag($refs.addButton)"
                  ref="addButton"
                  :class="{'btn-round color-wonder xs-f-small': isColorWonder}"
                ) Buy Now

                button.mr-btn.btn-inverse.btn-block.xs-f-xsmall.xs-mb-75m.max-at-tweak(
                  v-if="!hideFindPerfectShade && !advisorCompleted && version === 'B'"
                  @click="trackCTA('/shop/hair-color?rectype=color', 'Pdp CTAs')"
                ) find your perfect shade
                slot

      template(v-else-if="product.inventory_status == 'pre_order'")
        p.pre-order-text.xs-f-xmedium.md-f-large.lg-f-xmedium.text-center.max-at-tweak This product is currently available for pre&#8209;order. Shipments start {{ $formatDate(product.preorder_promise_date, 'MM/DD/YY') }}.
        .ctas-wrap.xs-12.text-center
          button.xs-12.lg-6.mr-btn.xs-f-xsmall.max-at-tweak(v-if="!preOrderId" type="button" ref="preOrderButton" @click="addToPreOrder") pre-order now {{ $currency(product.price) }}
          button.xs-12.lg-6.mr-btn.btn-inverse.bg-white.xs-f-xsmall.max-at-tweak(v-else type="button" ref="preOrderButton" @click="cancelPreOrder") cancel pre-order

</template>

<script>
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
  import WaitlistForm from "@components/PDP/WaitlistForm";
  import AddProduct from "@components/AddProduct";
  import StickyWrap from "@components/StickyWrap/stickyWrap";
  import AfterpayMessaging from '@components/AfterpayMessaging';
  import afterpayMixin from '@mixins/afterpayMixin';
  import ChangeColorCTAs from './ChangeColorCTAs';
  import AddPromo from "@components/AddPromo/AddPromo.vue";
  import MountedFlag from "@components/MountedFlag";

  export default {
    name: "PdpCTAs",

    components: {
      AddPromo,
      StickyWrap,
      AddProduct,
      WaitlistForm,
      AfterpayMessaging,
      ChangeColorCTAs,
      MountedFlag,
    },

    mixins: [afterpayMixin],
    inject: ['getObjProperty'],

    props: {
      ctaSource: {
        type: String,
        required: true
      },
    },

    data() {
      return {
        ctasInitialized: false, //- ensuring ctas show up only after we know which ones to show
        sticking: false,
        stopped: false
      };
    },

    computed: {
      ...mapState('global', ['windowData']),
      ...mapState('cms', ['cmsSettings']),

      ...mapState('pdp', [
        'version',
        'product',
        'purchaseType',
        'qty',
        'skipPurchasePanel',
        'preOrderId',
        'subscription',
        'addPerfectPair',
        'perfectPairSubPrice',
        'showPriceModule'
      ]),

      ...mapState('colorAdvisor', ['advisorCompleted']),
      ...mapState('refillCart', ['loadingRefillCart']),
      ...mapState('customer', ['cdata']),
      ...mapGetters('customer', ['closestColorbar']),
      ...mapGetters('pdp', ['displayTwoPrices']),

      afterpayMsgSize() {
        if (!this.isColorWonder || this.isMobile) {
          return 'xs';
        }
        return 'sm';
      },

      nearColorBar() {
        return !!this.closestColorbar;
      },

      isColorKit() {
        return this.getObjProperty(this, 'product.product_type') == 'color_kit';
      },

      isColorWonder() {
        return this.getObjProperty(this, 'product.product_type') == 'colorwonder';
      },

      productStrikePrice() {
        let price = this.product.oneTimeStrikePrice;

        if ((this.product.renewable && !this.skipPurchasePanel) || this.purchaseType == 'subscription') {
          price = this.product.subscriptionStrikePrice;
        }

        return price;
      },

      productPrice() {
        let price = this.product.price;

        if ((this.product.renewable && !this.skipPurchasePanel) || this.purchaseType == 'subscription') {
          price = this.product.sub_price;
        }

        return price;
      },

      buttonDisplayStrikePrice() {
        if (this.productStrikePrice && this.productStrikePrice !== this.productPrice && !this.addPerfectPair) {
          return this.productPrice;
        }
        return false;
      },

      buttonDisplayPrice() {
        if (this.addPerfectPair) {
          return this.perfectPairSubPrice;
        } else {
          return this.productStrikePrice || this.productPrice;
        }
      },

      showWaitlistForm() {
        return ['coming_soon', 'backordered'].includes(this.product.inventory_status);
      },

      isProductDiscontinued() {
        return ['discontinued'].includes(this.product.inventory_status);
      },

      addExtraPadding() {
        return this.windowData.isIosDevice && this.windowData.mobileNavHidden;
      },

      sameProductInSub() {
        let subedProdId = this.getObjProperty(this.subscription, 'product.id');
        return this.product.id == subedProdId;
      },

      displayFromText() {
        return this.displayTwoPrices && !this.skipPurchasePanel && !this.showPriceModule;
      },

      myColorUrl() {
        let url;
        let urlKey = this.getObjProperty(this.subscription, 'product.url_key');

        if (urlKey) {
          url = `/product/${urlKey}`;
        }

        return url;
      },

      activeSubAndSameProductNotSelected() {
        return Boolean(this.subscription.id && !this.sameProductInSub);
      },

      isMobile() {
        return this.windowData.breakpoint === 'mobile';
      },

      isDesktop() {
        return this.windowData.breakpoint === 'desktop';
      },

      hideFindPerfectShade() {
        return this.isColorWonder && this.isMobile;
      },

      isPerfectPairPdp() {
        return this.cmsSettings.perfectPair && this.addPerfectPair;
      }
    },

    watch: {
      product() {
        this.getPreOrderId();
      }
    },

    mounted() {
      if (this.cdata.activeSubscriber) {
        let unwatchCtaBtnVisibility = this.$store.watch(
          (state) => state.refillCart.loadingRefillCart,
          (newVal) => {
            if (!newVal) {
              this.ctasInitialized = true;
              unwatchCtaBtnVisibility();
            }
          }
        );

        this.initRefillCart();
      } else {
        this.ctasInitialized = true;
      }

      this.initColorAdvisor();
      this.getPreOrderId();

      //- fail safe to ensure CTA buttons don't stay hidden forever
      setTimeout(() => {
        this.ctasInitialized = true;
      }, 5000);
    },

    methods: {
      ...mapMutations('chatWidget', ['setDataForOpeningChat']),

      ...mapActions('pdp', [
        'cancelPreOrder',
        'getPreOrderId'
      ]),

      ...mapActions('cart', ['addToCart']),
      ...mapActions('refillCart', ['initRefillCart']),
      ...mapActions('colorAdvisor', ['initColorAdvisor']),
      ...mapActions('modal', ['showModal']),

      mainCtaText(canAddToRefillCart) {
        if (!this.skipPurchasePanel) {
          let insert = '';

          if (this.cmsSettings.perfectPair) {
            insert = this.addPerfectPair ? '2 Items ' : '1 Item ';
          }

          return `Add ${insert}to ${canAddToRefillCart ? 'Shipment' : 'bag'} `;
        } else {
          if (this.purchaseType == 'subscription') {
            return 'Subscribe';
          } else {
            return 'Add to bag';
          }
        }
      },

      addToPreOrder() {
        this.addToCart({
          cartType: 'preorder',
          ctaSource: `${this.ctaSource} CTAs`,
          productId: this.product.id,
          qty: this.qty
        }).then(() => {
          window.location = '/checkout';
        });
      },

      changeSubColor() {
        this.showModal({
          component: 'PdpChangeColorModal',
          props: {}
        });
      },

      setProduct() {
        return this.$router.push('/product/' + this.getObjProperty(this.subscription, 'product.url_key')).catch(() => { });
      }
    },
  };
</script>

<style scoped lang="stylus">
  .pdp-ctas
    margin-top 1em

    .side-padding
      padding 1em 4%

    .purchase-btn

      &.color-wonder
        letter-spacing -1px
        text-transform none
        padding 0.8em 1.6em

      &.has-from-text.half-button
        padding-top 0.4em
        padding-bottom 1.6em

        .from-text
        .cw-from-text
          position absolute
          left 0
          right 0
          top 1.7em

    .chat-btn
      padding-left 0.5em
      padding-right 0.5em

    &.waitlist
      padding-bottom 0

    .pre-order-text
      padding-bottom 0.5em

    .stock-warning-msg
      padding 1em 0.5em 1em 0
      background-color bg-color-error

    .discontinued-msg
      padding 0.5em
      margin 0.5em 0
      display flex
      align-items center
      background-color bg-color-error
      justify-content space-between

    @media mq-mobile
      padding 0 3%
      padding-bottom 1em

      &.waitlist
        padding 1em 0

        .help-msg
        .waitlist-form
          padding 1em 0


      .afterpay-message
        margin 0 -10px

    @media mq-tablet-less
      .sticky-wrap
        min-height 3.75em

        .ctas-wrap
          background #fff
          opacity 100
          transition(opacity 300ms ease-in-out)

        &.fixed
          .ctas-wrap
            position fixed
            padding 0.75em 5%
            z-index 49 // 1 less than the header z-index to ensure that mobile menu is always on top
            left 0
            right 0
            bottom 0
            animation(tofixedcta 300ms ease-in-out)
            @keyframes tofixedcta
              from
                opacity 0
              to
                opacity 100

            &.add-extra-padding
              padding-bottom 50px

          .hide-in-sticky
            display none

        &.stopped
          .ctas-wrap
            opacity 0
            pointer-events none

    @media mq-tablet
      padding 0 10%

    @media mq-desktop-plus
      .ctas-wrap
        position relative
        display flex
        flex-wrap wrap
        justify-content space-between

        .add-product-cta
          display flex
          flex-direction row
          justify-content space-between
          flex-wrap inherit
          .half-button
            max-width 49%
            width 49%
            flex-basis auto
            flex-grow 2

</style>
